(function() {
    'use strict';

    var component = {
        transclude: true,
        templateUrl:
            'app/js/components/controls/tooltip-icon-component/tooltip-icon.html' + itero.linkVersion,
        controller: controller,
        controllerAs: "vmTI",
        bindings: {
            ngShow: '<?',
            text: '@'
        }
    };

    iteroComponents.component('tooltipIcon', component);    

    function controller() {
        var ctrl=this;
        
        ctrl.$onInit = function () {
            if (ctrl.ngShow==undefined) {
                ctrl.ngShow=true;
            }
        };
    }
})();